import { Component } from '@angular/core';
import { WebSocketService } from '../../../web-socket.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrl: './main-dashboard.component.scss'
})
export class MainDashboardComponent {

  private destroy$ = new Subject<void>();
  connectedUsers: any[] = [];
  mytickets: any[] = [];
  myticketsTotal: number = 0;
  filaAtendimento: any[] = [];
  users: any[] = [];
  isLoadingChat: boolean = false;
  onlineUsersLoaded: boolean = false;


  isLoadingMyTickets: boolean = false;

  constructor( private webSocketService: WebSocketService, private http: HttpClient ) {
  }

  ngOnInit() {
  }

  loadOnlineUsers(){

    this.isLoadingChat = true;
    this.http.get<any>(`${environment.apiUrl}/usuario/onlinelist` ).subscribe(
      (response) => {
        this.users = response;
        this.isLoadingChat = false;
        this.onlineUsersLoaded = true;

      },
      (error) => {
        console.error('Error:', error);
      });


  }


  myTicketsLoaded = false;
  loadMyTikcets()
  {
    this.isLoadingMyTickets = true;
    this.http.get<any>(`${environment.apiUrl}/ticket/list/mytickets` ).subscribe(
      (response) => {
        this.mytickets = response.listaStatus;
        this.myticketsTotal = response.total;

        this.isLoadingMyTickets = false;
        this.myTicketsLoaded = true;
      },
      (error) => {
        console.error('Error:', error);
      });

  }


  usersLoaded = false;
  isLoadingFilaAtendimento = false;
  atendimentos: any[] = [];
  loadUsers() {
    this.isLoadingFilaAtendimento = true;

    this.http.get<any>(`${environment.apiUrl}/ticket/chat/queue` ).subscribe(
      (response) => {
        this.atendimentos = response;
        this.usersLoaded = true;
        this.isLoadingFilaAtendimento = false;
      },
      (error) => {
        console.error('Error:', error);
        this.isLoadingFilaAtendimento = false;
      });


  }
}
